import React, { useState } from "react";
import { connect } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import {
  updateCategory,
  getAllCategory,
} from "../../../actions/categoryAction";
import {
  Form,
  Input,
  Drawer,
  Button,
  Col,
  Row,
  message,
  TreeSelect,
  Space,
  Checkbox,
} from "antd";

const { TextArea } = Input;

const EditCategory = ({
  details,
  setUpdatelist,
  updateCategory,
  getAllCategory,
  List,
}) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const showDrawer = () => {
    getAllCategory();
    form.setFieldsValue(details);
    setVisible(true);
  };
  const onClose = () => {
    form.resetFields();
    setVisible(false);
  };

  const onFinish = (values) => {
    console.log(details);
    updateCategory(details.id, values);
    setUpdatelist(false);
    message.success(values.name + " Has been Updated");
    setVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Button type="primary" onClick={showDrawer}>
        Edit
      </Button>

      <Drawer
        title="Edit Category"
        width="50%"
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form
          form={form}
          layout="vertical"
          hideRequiredMark
          onFinish={onFinish}
          initialValues={details}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter user name" }]}
              >
                <Input placeholder="Please enter user name" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="slug"
                label="Slug"
                rules={[
                  {
                    required: true,
                    message: "Please enter slug",
                  },
                ]}
              >
                <Input
                  style={{ width: "100%" }}
                  placeholder="Please enter slug"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={23}>
              <Form.Item name="meta_title" label="Meta Title">
                <Input style={{ width: "100%" }} placeholder="Meta Title" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="meta_description" label="Meta Description">
                <TextArea
                  rows={1}
                  style={{ width: "100%" }}
                  placeholder="Meta Description"
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="meta_keywords" label="Meta Keywords">
                <TextArea
                  rows={1}
                  style={{ width: "100%" }}
                  placeholder="Meta Keywords"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={23}>
              <Form.Item name="page_title" label="Page Title">
                <Input style={{ width: "100%" }} placeholder="Page Title" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="page_description" label="Page Description">
                <ReactQuill theme="snow" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="Category_parent" label="Parent Category">
                <TreeSelect treeData={List} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Space>
                <Form.Item
                  name="online_visible"
                  valuePropName="checked"
                  checked
                >
                  <Checkbox>Active category !</Checkbox>
                </Form.Item>
              </Space>
            </Col>
          </Row>

          <Form.Item>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    List: state.category.categorylist,
  };
};

export default connect(mapStateToProps, { updateCategory, getAllCategory })(
  EditCategory
);
